import React, { useEffect } from 'react'
import styled from 'styled-components'
import {
  ConditionFormContainer,
  REQUEST_FORM_PAGES,
} from 'components/scouts/request-form/condition/condition-form-container'
import { QuestionText } from 'components/scouts/common/styles'
import { CheckboxChip, Chip, ChipType } from 'components/common/chip'
import { useRequestFormOptions, useScoutMyRequest } from 'apis/hooks'
import { useStores } from 'stores/globals'
import { observer } from 'mobx-react'
import { analytics } from 'infra/analytics'
import {
  FullWidthChipContainer,
  OptionExplainText,
  QuestionOptionWrapper,
  SteveIconAndQuestionWrapper,
} from 'components/scouts/request-form/condition/styles'
import { Column } from 'components/common/layout'
import { RadioChip } from 'components/common/chip'
import { SteveIcon } from 'components/scouts/request-form/condition/steve-icon'
import { requireLogin } from 'components/misc/hoc'
import { useRouter } from 'next/router'
import { BsCaretDownFill } from 'react-icons/bs'
import { theme } from 'infra/theme'
import { useIsDesktopCSR } from 'utils/hooks'

const JobSearchStatus: React.FC = () => {
  const { data: myRequest } = useScoutMyRequest()
  const { scoutConditionFormStore } = useStores()
  const router = useRouter()
  useEffect(() => {
    analytics.traffic('srRegi_S1_jsu_pv_status')
  }, [])
  useEffect(() => {
    if (
      !myRequest?.lastSavedStep ||
      scoutConditionFormStore.hasMovedToLastSavedStep
    )
      return
    router.replace({
      pathname: REQUEST_FORM_PAGES[myRequest.lastSavedStep],
      query: router.query,
    })
    scoutConditionFormStore.setHasMovedToLastSavedStep(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myRequest])
  if (myRequest === undefined) return null
  return (
    <ConditionFormContainer>
      <QuestionOptionWrapper>
        <SteveIconAndQuestionWrapper>
          <SteveIcon />
          <QuestionText>{'구직 상태가 어떻게 되시나요?'}</QuestionText>
        </SteveIconAndQuestionWrapper>
        <React.Suspense>
          <JobSearchStatusSelector />
        </React.Suspense>
      </QuestionOptionWrapper>
    </ConditionFormContainer>
  )
}

const JobSearchStatusSelector: React.FC = observer(() => {
  const { scoutConditionFormStore: scoutRequestFormStore } = useStores()
  const { data } = useRequestFormOptions()
  const isDesktop = useIsDesktopCSR()
  return (
    <FullWidthChipContainer width={500} style={{ gap: 16 }}>
      {data?.workLevels.map((workLevel) => {
        const isSelected = scoutRequestFormStore.form.workLevel === workLevel.id
        const jobInterestLevelsForSelected = data?.jobInterestLevels.filter(
          (item) => item.workLevelId === workLevel.id,
        )
        return (
          <div key={workLevel.id}>
            <RadioChip
              isSelected={isSelected}
              isFullWidth
              onClick={() => {
                scoutRequestFormStore.setWorkLevel(workLevel.id)
              }}
            >
              {workLevel.description}
            </RadioChip>
            {isSelected && jobInterestLevelsForSelected.length > 0 && (
              <SubChipContainer>
                <BsCaretDownFill
                  color={theme.color.primary}
                  size={isDesktop ? 18 : 14}
                />
                {jobInterestLevelsForSelected.map((jobInterestLevel) => {
                  const isSelected =
                    scoutRequestFormStore.form.jobInterestLevel ===
                    jobInterestLevel.id
                  return (
                    <Chip
                      key={jobInterestLevel.id}
                      isSelected={isSelected}
                      variant={ChipType.OUTLINED}
                      onClick={() => {
                        scoutRequestFormStore.setJobInterestLevel(
                          jobInterestLevel.id,
                        )
                      }}
                      isFullWidth
                    >
                      {jobInterestLevel.description}
                    </Chip>
                  )
                })}
              </SubChipContainer>
            )}
          </div>
        )
      })}
      <FullWidthChipContainer width={307} style={{ margin: '60px auto 0' }}>
        <CheckboxChip
          isSelected={scoutRequestFormStore.form.isActivelySeeker}
          variant={ChipType.FILLED_PRIMARY}
          isFullWidth
          onClick={() =>
            scoutRequestFormStore.setIsActivelySeeker(
              !scoutRequestFormStore.form.isActivelySeeker,
            )
          }
        >
          적극 구직 중이에요
        </CheckboxChip>
        <OptionExplainText>
          스타트업이 보는 내 프로필에 표시돼요
        </OptionExplainText>
      </FullWidthChipContainer>
    </FullWidthChipContainer>
  )
})

const SubChipContainer = styled(Column)`
  margin: 8px 52px 0;
  gap: 8px;
  align-items: center;
  @media ${(p) => p.theme.deviceSize.mobile} {
    margin: 8px 24px 0;
  }
`

export default requireLogin(JobSearchStatus)
